/**
 * Check `on|` hooks (replaced by `_-_`. Example: `on_-_start`)
 * @param {Map<String, any>} property
 * @param {OptionsListMapProps} options
 * @param {Boolean} [isStep]
 */
const checkReferenceHooks = (property, options, isStep = false) => {
  let referenceHook = false;

  property.set("has-start-hook", false);
  property.set("has-finish-hook", false);
  property.set("has-offset-hook", false);
  property.set("offset-hooks", new Map());

  if (!options) {
    return;
  }

  for (const option of options.keys()) {
    if (!/^on\_-_/.test(option)) {
      continue;
    }

    /** On start hook (`on|start`) */
    if (/^on\_-_start/.test(option)) {
      property.set("has-start-hook", true);
      referenceHook = true;
    }

    /** On finish hook (`on|finish`) */
    if (/^on\_-_finish/.test(option)) {
      property.set("has-finish-hook", true);
      referenceHook = true;
    }

    /** On offset hook (`on|40%`) */
    if (/^on\_-_\d/.test(option)) {
      const exec = /\_-_(.*?)%+/.exec(option);
      const number = exec ? +exec[1] : 0;
      const map = new Map();

      map.set("enter-active", false);
      map.set("leave-active", false);
      map.set("hook", isStep ? option : `o_${option}`);

      property.get("offset-hooks").set(number / 100, map);
      property.set("has-offset-hook", true);
      referenceHook = true;
    }
  }

  property.set("has-reference-hook", referenceHook);
};

export default checkReferenceHooks;
